import React, { useState, useEffect, useRef } from 'react';
import { Popover, Tooltip, Button, Modal } from 'antd';
import QRCode from 'qrcode.react';
import { useTranslation } from 'react-i18next';
import TokenIcon from '../../TokenIcon';
import formatCurrency from '../../../utils/currencyFormatter';
import { ReactComponent as QRIcon } from '../../../img/default-svg/bx_qr.svg';
import { ReactComponent as QRIconInex } from '../../../img/inex/bx_qr.svg';
import { ReactComponent as QRIconInsta } from '../../../img/instaXchange/bx_qr.svg';
import { ReactComponent as QRIconCoinera } from '../../../img/coinera/bx_qr.svg';
import { ReactComponent as Copy } from '../../../img/default-svg/copy.svg';
import { ReactComponent as CopyInex } from '../../../img/inex/copy.svg';
import { ReactComponent as CopyInsta } from '../../../img/instaXchange/copy.svg';
import { ReactComponent as CopyCoinera } from '../../../img/coinera/copy.svg';
import './style.scss';
import { identity } from '../../../utils/getIdentity';

const copyIcon = {
  cpay: <Copy />,
  nfg: <Copy />,
  finvaro: <Copy />,
  clarnium: <Copy />,
  inex: <CopyInex />,
  insta: <CopyInsta />,
  coinera: <CopyCoinera />
}

const CurrencyItem = ({
  currencyId,
  setCurrencyId,
  currencyBalance,
  title,
  currencies,
  name
}) => {
  const qrIcon = {
    cpay: <QRIcon onClick={event => openModal(event, currencyBalance)} />,
    nfg: <QRIcon onClick={event => openModal(event, currencyBalance)} />,
    finvaro: <QRIcon onClick={event => openModal(event, currencyBalance)} />,
    clarnium: <QRIcon onClick={event => openModal(event, currencyBalance)} />,
    inex: <QRIconInex onClick={event => openModal(event, currencyBalance)} />,
    insta: <QRIconInsta onClick={event => openModal(event, currencyBalance)} />,
    coinera: <QRIconCoinera onClick={event => openModal(event, currencyBalance)} />
  }

  const [showPopover, setShowPopover] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [showQRModal, setShowQRModal] = useState(null);
  const [showAddressPopover, setShowAddressPopover] = useState(false);
  const addressPopoverTimer = useRef(null);

  const timer = useRef(null);
  const { t } = useTranslation();

  const getMinReplenishValue = () => {
    const currency = currencies.find(currency => currency._id === currencyBalance.currency.id);
    if (!currency) return '-';
    return `0.${new Array(currency.decimals).join(0)}1`;
  };

  useEffect(() => () => {
    clearTimeout(timer);
    timer.current = null;
  });

  useEffect(() => {
    showPopover && setShowTooltip(false);
  }, [showPopover]);

  const copyHandler = (text, event) => {
    event.stopPropagation();
    navigator.clipboard.writeText(text);
    setShowPopover(true);
    timer.current = setTimeout(() => setShowPopover(false), 1000);
  };

  const openModal = (event, currencyBalance) => {
    event.stopPropagation();
    setShowQRModal(currencyBalance);
  };

  const addressCopyHandler = () => {
    navigator.clipboard.writeText(currencyBalance.wallet);
    setShowAddressPopover(true);
    addressPopoverTimer.current = setTimeout(() => setShowAddressPopover(false), 1000);
  };

  useEffect(() => {
    return () => {
      clearTimeout(addressPopoverTimer);
      addressPopoverTimer.current = null;
    };
  });

  const truncate = function (fullStr = '', strLen, separator) {
    if (fullStr.length <= strLen) return fullStr;

    separator = separator || '...';

    var sepLen = separator.length,
      charsToShow = strLen - sepLen,
      frontChars = Math.ceil(charsToShow / 2),
      backChars = Math.floor(charsToShow / 2);

    return fullStr.substring(0, frontChars) + separator + fullStr.substring(fullStr.length - backChars);
  };

  return (
    <>
      <div
        className={`currency-item currency-item-${identity} ${currencyId === currencyBalance.currency.id && `currency-item_active currency-item_active-${identity}`}`}
        onClick={() => {
          document.getElementsByClassName('main-layout__content-wrap')[0].scrollTo({
            top: 0,
            behavior: 'smooth',
          });
          setCurrencyId(currencyBalance.currency.id);
          localStorage.setItem('currId', currencyBalance.currency.id)
        }}
      >
        <div className="currency-item__inner">
          <div className="currency-item_left">
            <div className="currency-item__name-wrap">
              <TokenIcon className="currency-item__logo" tokenName={currencyBalance.currency.name} />
              {process.env.REACT_APP_IS_AVAILABLE_NEW_WALLET === 'true' ? (
                <div className={`currency-item__title currency-item__title-${identity}`}>
                  <div>{title}</div>
                  <div className="currency-item__title--name">{name}</div>
                </div>
              ) : (
                <div className={`currency-item__title currency-item__title-${identity}`}>{title}</div>
              )}
            </div>
            {process.env.REACT_APP_IS_AVAILABLE_NEW_WALLET === 'false' ? (
              <div className="currency-item__qr-wrap">
                {qrIcon[identity]}
                <Tooltip
                  title={t("clickToCopy")}
                  visible={showTooltip}
                  onVisibleChange={isVisible => setShowTooltip(isVisible)}
                >
                  <div>
                    <Popover content={t("copied")} trigger="click" visible={showPopover} hidden={true}>
                      <div
                        className={`currency-item__wallet currency-item__wallet-${identity}`}
                        onClick={event => copyHandler(currencyBalance.wallet, event)}
                      >
                        {truncate(currencyBalance.wallet, 14, "..")}
                      </div>
                    </Popover>
                  </div>
                </Tooltip>
              </div>
            ) : null}
          </div>

          <div className="currency-item_right">
            <div className={`currency-item__amount currency-item__amount-${identity}`}>
              {currencyBalance.balance.value} {process.env.REACT_APP_IS_AVAILABLE_NEW_WALLET === 'false' ? currencyBalance.currency.name : null}
            </div>
            <div
              className={`currency-item__usd currency-item__usd-${identity}`}>{formatCurrency(currencyBalance.balance.usd)}</div>
          </div>
        </div>
        {/* <div className="currency-item__min-replenish">Minimum deposit amount for wallet is {getMinReplenishValue()}</div> */}
      </div>

      {showQRModal !== null && currencyBalance.wallet ? (
        <Modal
          className={`qr-modal qr-modal-${identity}`}
          title={t("merchants.replenish")}
          width={380}
          visible={showQRModal}
          footer={null}
          onCancel={() => setShowQRModal(null)}
        >
          <div className="main">
            <div className="qr-block">
              <Popover
                title=""
                content={t('copied')}
                trigger="click"
                visible={showAddressPopover}
                className="detailed-checkout__popover"
              >
                <div className={`qr-block__address qr-block__address-${identity}`} onClick={addressCopyHandler}>
                  <div>{`${showQRModal?.currency?.name?.toUpperCase()} ${t('address')}`}</div>
                  <div className={`qr-block__copy-block qr-block__copy-block-${identity}`}>
                    <div>{`${showQRModal.wallet.slice(0, 4)}...${showQRModal.wallet.slice(-4)}`}</div>
                    {copyIcon[identity]}
                  </div>
                </div>
              </Popover>
            </div>
            <QRCode value={showQRModal.wallet} size={205} />

            <Button onClick={() => setShowQRModal(null)}>Ok</Button>
          </div>
        </Modal>
      ) : (
        <></>
      )}
    </>
  );
};

export default CurrencyItem;
